import React from "react";
import { NavLink } from "react-router-dom";

export const NavBarBrand = () => {
  const logo = process.env.REACT_APP_NAV_LOGO;
  
  return (
    <div className="nav-bar__brand">
      <NavLink to="/">
        <img
          className="nav-bar__logo"
          src={logo}
          alt="Board Game Library Admin logo"
          width="122"
          height="36"
        />
      </NavLink>
    </div>
  );
};
